"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _Logging = require("./Logging");

var _mobx = require("mobx");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTSEPScripts = function useTSEPScripts(cardStore) {
  var useExternalMessaging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      manifestURL = _useState4[0],
      setManifestURL = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showNickname = _useState6[0],
      setShowNickname = _useState6[1];

  var cardElem = (0, _react.useRef)(null);
  var cvvElem = (0, _react.useRef)(null);
  var expElem = (0, _react.useRef)(null);

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      cardNumberError = _useState8[0],
      setCardNumberError = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      expirationError = _useState10[0],
      setExpirationError = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      cvvError = _useState12[0],
      setCvvError = _useState12[1];

  (0, _react.useEffect)(function () {
    /**
     *Handler function required by TSEP, TSYS calls this function directly
     *See dev site for different events: https://developerportal.transit-pass.com/developerportal/resources/dist/#/api-specs/.%2Fassets%2Fbuild%2Fapi%2FTSEP%2FEvent_Handling%2Findex.html%23
     *
     * @param {String} eventType identifies the type of event to handle
     * @param {Object} event object containing event details
     */
    var tsepFunc = "function tsepHandler(eventType, event) {\n      let newEvent;\n      switch (eventType) {\n        case \"FieldValidationErrorEvent\":\n          newEvent = new CustomEvent(\"element-validation\", {\n            detail: event\n          });\n          break;\n        case \"TokenEvent\":\n          newEvent = new CustomEvent(\"token-creation\", {\n            detail: event\n          });\n          break;\n        case \"ErrorEvent\":\n          if (window.webkit && window.webkit.messageHandlers.error) {\n            window.webkit.messageHandlers.error.postMessage(event);\n          } else {\n            newEvent = new CustomEvent(\"error-message\", {\n              detail: {\n                message: \"There was an issue communicating with the server. Please contact the office to process your payment until we can address the issue.\"\n              }\n            })\n          }\n          break;\n        default:\n          break;\n      }\n      if (newEvent !== undefined) {\n        document.dispatchEvent(newEvent);\n      }\n    }";
    /**
     *Initialize form with necessary data
     *
     * @param {Object} data object with manifestURL, zipRequired, addressRequired, and showNickname properties
     */

    var initFunc = "function initializeForm(data) {\n      const jsonObj = JSON.parse(window.atob(data));\n      const event = new CustomEvent(\"initialize-form\", {\n        detail: jsonObj\n      });\n      document.dispatchEvent(event);\n    }";
    /**
     * Retrieve CardModel data from form.
     * Dispatches "retrieve-data" event, which results in sending the current CardModel data to the caller
     *
     */

    var retrieveFunc = "function retrieveFormData() {\n      const event = new CustomEvent(\"retrieve-data\");\n      document.dispatchEvent(event);\n    }";
    /**
     * Add necessary scripts to <head>. tsepHandler function is always required,
     * other functions are only needed if TSEP is being accessed as a stand-alone page
     *
     */

    var addTSEPHandler = function addTSEPHandler() {
      var headElement = document.getElementsByTagName("head")[0];
      var newScript = document.createElement("script");
      var scriptString = tsepFunc.toString();

      if (useExternalMessaging) {
        scriptString += "\n" + initFunc + "\n" + retrieveFunc;
      }

      newScript.innerHTML = scriptString;
      newScript.id = "tsep-handler";
      newScript.type = "text/JavaScript";
      headElement.appendChild(newScript);
    };

    addTSEPHandler();
  }, [useExternalMessaging]);
  (0, _react.useEffect)(function () {
    /**
     * Load TSEP scripts into the DOM.
     * First the "manifest" script is loaded, and that script in turn will load additional scripts into the DOM
     *
     * @param {*} event The event object, event.detail contains manifestURL, addressRequired, zipRequired, and showNickname if the event is "initialize-form"
     */
    var loadTSEPScripts = function loadTSEPScripts(event) {
      var isFormInitialization = event.type === "initialize-form";
      var headElement = document.getElementsByTagName("head")[0];
      var scripts = headElement.getElementsByTagName("script");

      for (var index = scripts.length; index >= 0; index--) {
        var element = scripts[index];

        if (element && element.src.includes("transit-tsep-web")) {
          headElement.removeChild(element);
        }
      }

      var newScript = document.createElement("script");
      newScript.src = event.detail.manifestURL; //If this is the initial load, need to handle authentication error.
      //If it's a reload, we already loaded once without issue so shouldn't need to worry about authentication failing

      if (isFormInitialization) {
        newScript.onload = function () {
          //If the TSEP manifest script fails authentication, it sets a function in window.onload
          //that will send the error to tsepHandler. Since the script is being added to the DOM after loading is
          //already complete, need to do some special checking by forcing a "load" event.
          var loadEvent = document.createEvent("HTMLEvents");
          loadEvent.initEvent("load", true);
          window.dispatchEvent(loadEvent); //After sending the load event to make sure any authentication error gets handled,
          //clear out these onload functions from the script and the window

          delete newScript.onload;

          window.onload = function () {};
        };
      }

      headElement.appendChild(newScript);

      if (isFormInitialization) {
        (0, _Logging.log)(event.detail);

        if (event.detail.manifestURL) {
          setManifestURL(event.detail.manifestURL);
        }

        if (cardStore.setRequiredFields) {
          cardStore.setRequiredFields(event.detail.addressRequired, event.detail.zipRequired);
        }

        setShowNickname(event.detail.showNickname);
        setLoading(false);
        (0, _Logging.log)("initialized form");
      }
    };
    /**
     * Handling for "retrieve-data" event. Posts a message to controller with the state of the Card Store as a JSON object     *
     */


    var retrieveData = function retrieveData() {
      (0, _Logging.log)("retrieve-data called");
      (0, _Logging.postWebkitMessage)("postFormData", (0, _mobx.toJS)(cardStore));
    };
    /**
     * Handle the "token-creation" event.
     * If a token was successfully created, set the token, cvv, and expiration date in the card model
     * If tokenization failed, show alert with error message and reload the TSEP scripts to try again.
     *
     * @param {*} event event object for token-creation event
     */


    var handleTokenCreate = function handleTokenCreate(event) {
      var _event$detail = event.detail,
          cardType = _event$detail.cardType,
          cvv2 = _event$detail.cvv2,
          expirationDate = _event$detail.expirationDate,
          message = _event$detail.message,
          responseCode = _event$detail.responseCode,
          status = _event$detail.status,
          tsepToken = _event$detail.tsepToken;

      if (status !== "PASS") {
        var errorMessage = "Failed to generate token. ".concat(responseCode, ": ").concat(message);
        alert(errorMessage);
        /**
         * Replace TSEP fields with new versions.
         * This is needed because the TSEP scripts add event handlers and other baggage to these dom elements,
         * so when we want to refresh the form due to an error we need to completely replace the elements
         */

        if (cardElem) {
          var cardCopy = cardElem.current.cloneNode();
          cardElem.current.parentNode.replaceChild(cardCopy, cardElem.current);
          cardElem.current = cardCopy;
        }

        if (cvvElem) {
          var cvvCopy = cvvElem.current.cloneNode();
          cvvElem.current.parentNode.replaceChild(cvvCopy, cvvElem.current);
          cvvElem.current = cvvCopy;
        }

        if (expElem) {
          var expCopy = expElem.current.cloneNode();
          expElem.current.parentNode.replaceChild(expCopy, expElem.current);
          expElem.current = expCopy;
        }

        loadTSEPScripts({
          detail: {
            manifestURL: manifestURL
          }
        });
        return;
      }

      cardStore.setTokenResults(tsepToken, cvv2, expirationDate, cardType);
      (0, _Logging.log)("token created");
      (0, _Logging.log)((0, _mobx.toJS)(cardStore));
      cardElem.current.disabled = true;
      cvvElem.current.disabled = true;
      expElem.current.disabled = true;
    };
    /**
     * Handling for "element-validation" event sent by tsepHandler function.
     * When validation fails for card number, cvv, or expiration date, this function will be called and set the error message for the given field
     *
     * @param {*} event event object for element-validation event
     */


    var handleValidationError = function handleValidationError(event) {
      var _event$detail2 = event.detail,
          fieldName = _event$detail2.fieldName,
          message = _event$detail2.message;
      (0, _Logging.log)(event.detail);

      switch (fieldName) {
        case "tsep-cardNum":
          setCardNumberError(message);
          break;

        case "tsep-cvv2":
          setCvvError(message);
          break;

        case "tsep-datepicker":
          setExpirationError(message);
          break;

        default:
          break;
      }
    };

    if (manifestURL === "") {
      (0, _Logging.postWebkitMessage)("initForm");
    }

    document.addEventListener("initialize-form", loadTSEPScripts);
    document.addEventListener("tokenization-failed", loadTSEPScripts);
    document.addEventListener("retrieve-data", retrieveData);
    document.addEventListener("token-creation", handleTokenCreate);
    document.addEventListener("element-validation", handleValidationError);
    return function () {
      document.removeEventListener("initialize-form", loadTSEPScripts);
      document.removeEventListener("tokenization-failed", loadTSEPScripts);
      document.removeEventListener("retrieve-data", retrieveData);
      document.removeEventListener("token-creation", handleTokenCreate);
      document.removeEventListener("element-validation", handleValidationError);
    };
  }, [cardStore, manifestURL]);
  return [{
    cardStore: cardStore,
    showNickname: showNickname,
    manifestURL: manifestURL,
    cardElem: cardElem,
    cvvElem: cvvElem,
    expElem: expElem,
    cardNumberError: cardNumberError,
    expirationError: expirationError,
    cvvError: cvvError,
    clearCardNumberError: function clearCardNumberError() {
      return setCardNumberError("");
    },
    clearExpirationError: function clearExpirationError() {
      return setExpirationError("");
    },
    clearCvvError: function clearCvvError() {
      return setCvvError("");
    },
    setShowNickname: setShowNickname
  }, loading];
};

var _default = useTSEPScripts;
exports.default = _default;